<script lang="ts">
  import { db, auth } from '../firebase-settings'
  import { doc, setDoc } from "firebase/firestore"; 
  import { createUserWithEmailAndPassword } from "firebase/auth";
  import { Link, navigate } from 'svelte-routing'

  let email:string
  let password: string
  let name: string
  let city: string
  let zip: string|number
  let region: string

  $:showEmailError = false

  let src = 'logo.svg'

  let spinner = false

  let signupUser = async ({email, password, name, city, region, zip}) => {
    spinner = true
    showEmailError = false;
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email.toLowerCase(), password)
      let user = userCredential.user
      await setDoc(doc(db, 'plans', user.uid), { name, email, investments: [], city, region, zip, withdrawalRequest: false, createdAt: new Date().getTime() })
      console.log(user)
      spinner = false
      navigate('/login', { replace: true})
    } catch (error) {
      spinner = false;
      if (error.message.includes('auth/email-already-in-use')) {
        alert('email already taken');
        showEmailError = true;
      }
    }
  }
</script> 


<div class="flex bg-gray-100 items-center justify-center px-4 mx-aut py-24">
  <div class="w-full max-w-md">
    <form on:submit|preventDefault={e => signupUser({ email, password, name, city, region, zip })} class="bg-white shadow-lg rounded-md px-12 pt-6 pb-8 mb-4">
      <div
        class="text-gray-800 text-2xl flex justify-center py-2 mb-4"
      >
        <img {src} alt="large pool mining" class="mx-auto w-44 h-24 object-fit" />
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="name"
        >
          Name
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="email"
          type="text"
          required
          bind:value={name}
        />
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="username"
        >
          Email
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="email"
          type="email"
          required
          bind:value={email}
        />
        {#if showEmailError }
          <small class="text-red-600">email already in use</small>
        {/if}
      </div>
      <div class="mb-2">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="password"
        >
          Password
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          type="password"
          placeholder="Password"
          name="password"
          bind:value={password}
          required
          autocomplete="current-password"
        />
        
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="city"
        >
          City
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="text"
          type="text"
          required
          bind:value={city}
        />
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="region"
        >
          Region
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="email"
          type="text"
          required
          bind:value={region}
        />
      </div>
      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-normal mb-2"
          for="region"
        >
          Zip
        </label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="email"
          type="text"
          required
          bind:value={zip}
        />
      </div>
      <div class="flex flex-column items-center justify-between">
        {#if spinner} 
          <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit">Sign In 
            <i class="fas fa-spinner ml-2 fa-spin"></i>
          </button>
        {:else}
          <button class="px-4 py-2 rounded text-white inline-block shadow-lg bg-blue-500 hover:bg-blue-600 focus:bg-blue-700" type="submit">Sign In
          </button>
        {/if}
        
        
      </div>
      <Link
          class="inline-block align-baseline font-normal text-sm text-blue-500 hover:text-blue-800"
          to="/login"
        >
          Already have an account? Login
        </Link>
    </form>
    <p class="text-center text-gray-500 text-xs">
      &copy;2020 Gau Corp. All rights reserved.
    </p>
  </div>
</div>